import { ApiPath } from "enums";
import { Get, Post, Put } from "utils";

export const getCampaigns = async () => {
  const res = await Get(ApiPath.SurveyCampaign);
  return res.data;
};

export const createCampaign = async ({
  description,
  campaignCode,
  campaignDate,
  status = "active",
  endDate,
  location,
  surveyType,
  campaignType,
  surveyQuestionDocument,
}) => {
  const formData = new FormData();

  formData.append("description", description);
  formData.append("campaignCode", campaignCode);
  formData.append("campaignDate", campaignDate);
  formData.append("status", status);
  formData.append("endDate", endDate);
  formData.append("location", location);
  formData.append("surveyType", surveyType);
  formData.append("campaignType", campaignType);

  if (surveyQuestionDocument) {
    formData.append("surveyQuestionDocument", surveyQuestionDocument);
  }

  const res = await Post(ApiPath.SurveyCampaign, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return res.data;
};

export const endCampaign = async ({ campaignCode }) => {
  const res = await Post(`${ApiPath.SurveyCampaign}/${campaignCode}/end`);
  return res.data;
};

export const getCampaignQuestions = async ({ campaignId }) => {
  const res = await Get(`${ApiPath.SurveyCampaign}/${campaignId}/questions`);
  return res.data;
};

export const getCampaignByCode = async ({ campaignCode }) => {
  const res = await Get(`${ApiPath.SurveyCampaign}/code/${encodeURIComponent(campaignCode)}`);
  return res.data;
};

export const saveCampaignQuestions = async ({ campaignId, payload }) => {
  const res = await Post(`${ApiPath.SurveyCampaign}/${campaignId}/questions`, payload);
  return res.data;
};

export const getQuestionMediaUploadUrl = async ({ campaignId, contentType, extension }) => {
  const body = {
    contentType,
  };

  if (extension) {
    body.extension = extension;
  }

  const res = await Post(`${ApiPath.SurveyCampaign}/${campaignId}/question-media/upload-url`, body);
  return res.data;
};

export const uploadQuestionMediaToS3 = async ({ uploadUrl, file, contentType }) => {
  const response = await fetch(uploadUrl, {
    method: "PUT",
    headers: {
      "Content-Type": contentType,
    },
    body: file,
  });

  if (!response.ok) {
    const uploadError = new Error("Failed to upload media to storage.");
    uploadError.status = response.status;
    uploadError.statusText = response.statusText;
    throw uploadError;
  }

  return true;
};

export const updateCampaign = async ({
  campaignCode,
  description,
  campaignDate,
  status,
  endDate,
  location,
  surveyType,
  surveyQuestionDocument,
}) => {
  const formData = new FormData();

  if (description != null) formData.append("description", description);
  if (campaignCode != null) formData.append("campaignCode", campaignCode);
  if (campaignDate != null) formData.append("campaignDate", campaignDate);
  if (status != null) formData.append("status", status);
  if (endDate != null) formData.append("endDate", endDate);
  if (location != null) formData.append("location", location);
  if (surveyType != null) formData.append("surveyType", surveyType);

  if (surveyQuestionDocument) {
    formData.append("surveyQuestionDocument", surveyQuestionDocument);
  }

  const res = await Put(`${ApiPath.SurveyCampaign}/${encodeURIComponent(campaignCode)}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return res.data;
};
